<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("E Wallet Report") }}
      </div>
      <small><em>{{ $t("* As Per Business Date") }}</em></small>

      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("from") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("to") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getEWalletReport('N', 'N')"
            >
              {{ $t("fetch") }}
            </button>
          </div>

          <div
            v-if="ewalletRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <!-- <div class="mx-1">{{ $t("download") }} as:</div> -->
            <!-- s -->

            <a
              target="_blank"
              @click="getEWalletReport('Y', 'N')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getEWalletReport('N', 'Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="font-weight-bold">
            <th>Date</th>
            <th>Transaction Id</th>
            <th>Receipt No</th>
            <th>Invoice No</th>
            <th>Transaction Type</th>
            <th>Movie/Item</th>
            <th>Qty</th>
            <th>Amount</th>
            <th>Payment Method</th>
            <th>Remarks</th>
            <th>Total Gross Amount (Excl. Ewallet)</th>
            <th>Total Booking Fees</th>
            <th>Member ID</th>
            <th>Member Mobile No.</th>
            <th>Member Email ID</th>
          </thead>
          <tbody v-if="ewalletRecords.length > 0">
            <tr
              v-for="(ewalletObj, ewalletIndex) in ewalletRecords"
              :key="ewalletIndex"
            >
              <td class="text-left">{{ ewalletObj.business_date }}</td>
              <td class="text-left">{{ ewalletObj.transaction_id }}</td>
              <td class="text-left">{{ ewalletObj.receipt_number }}</td>
              <td class="text-left">{{ ewalletObj.invoice_number }}</td>
              <td class="text-left">{{ ewalletObj.transaction_type }}</td>
              <td class="text-left">
                {{
                  ewalletObj.movie_name
                    ? ewalletObj.movie_name
                    : ewalletObj.item_name || "-"
                }}
              </td>
              <td class="text-right">{{ ewalletObj.quantity }}</td>
              <td class="text-right">
                {{ currFormat(ewalletObj.e_wallet_amount) }}
              </td>
              <td class="text-left">{{ ewalletObj.payment_mode }}</td>
              <td class="text-left">{{ ewalletObj.remarks }}</td>
              <td class="text-right">
                {{ currFormat(ewalletObj.gross_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(ewalletObj.booking_fees) }}
              </td>
              <td class="text-left">{{ ewalletObj.cust_member_id }}</td>
              <td class="text-left">{{ ewalletObj.cust_mobile }}</td>
              <td class="text-left">{{ ewalletObj.cust_email }}</td>
            </tr>
            <tr class="font-weight-bold">
              <td colspan="6" class="text-left">Total</td>
              <td class="text-right">{{ grandTotal.total_quantity }}</td>
              <td class="text-right">
                {{ currFormat(grandTotal.total_e_wallet_amount) }}
              </td>
              <td></td>
              <td></td>
              <td class="text-right">
                {{ currFormat(grandTotal.total_gross_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.total_booking_fees) }}
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="15">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      ewalletRecords: [],
      excelFilePath: "",
      grandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    onChangeDate(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`,
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn ||
              `RawMaterialSupplierWiseCost-${
                this.dropDown.selectedCinemaName
              }.${type || "xlsx"}`
          );
    },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getEWalletReport(isExcel = "N", isPdf = "N") {
      this.ewalletRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf,
      };
      ReportsService.GetEWalletReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.ewalletRecords = [...data.Records];
            this.grandTotal = data.grandTotal;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>


  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid gray;
     font-size: 12px;
  }
  .swc-report-table td {
    white-space: nowrap !important;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid gray !important;
  }
  .swc_table_header th {
    border: 1px solid gray !important;
  }
  .no_border {
    border: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/ewalletReport.vue